import { Component } from '@angular/core';

@Component({
  selector: 'app-uploads',
  templateUrl: './uploads.component.html',
  styleUrl: './uploads.component.scss',
  standalone: false,
})
export class UploadsComponent {}
